import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-596396fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content_wrapper wrapper" }
const _hoisted_2 = { class: "content_body" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "back_button_img",
  src: "/assets/img/arrow-left.svg"
}, null, -1))
const _hoisted_4 = { class: "content_body" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "component_title mb-2" }
const _hoisted_7 = { class: "four_block_wrapper" }
const _hoisted_8 = { class: "half_left_wrapper" }
const _hoisted_9 = { class: "four_block_left mb-4" }
const _hoisted_10 = { class: "block_label" }
const _hoisted_11 = { class: "block_info" }
const _hoisted_12 = { class: "four_block_right mb-4" }
const _hoisted_13 = { class: "block_label" }
const _hoisted_14 = { class: "block_info" }
const _hoisted_15 = { class: "half_right_wrapper" }
const _hoisted_16 = { class: "four_block_left mb-4" }
const _hoisted_17 = { class: "block_label" }
const _hoisted_18 = { class: "block_info" }
const _hoisted_19 = { class: "four_block_right mb-4" }
const _hoisted_20 = { class: "block_label" }
const _hoisted_21 = { class: "block_info" }
const _hoisted_22 = { class: "two_block_wrapper" }
const _hoisted_23 = { class: "top_half_left mb-4" }
const _hoisted_24 = { class: "block_label" }
const _hoisted_25 = { class: "block_info" }
const _hoisted_26 = { class: "top_half_right mb-4" }
const _hoisted_27 = { class: "block_label" }
const _hoisted_28 = { class: "block_info" }
const _hoisted_29 = { class: "" }
const _hoisted_30 = { class: "block_label" }
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_33 = { class: "block_label" }
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "button_wrapper mt-3" }
const _hoisted_36 = ["diasbled"]
const _hoisted_37 = ["diasbled"]
const _hoisted_38 = ["diasbled"]
const _hoisted_39 = ["diasbled"]
const _hoisted_40 = { class: "content_body" }
const _hoisted_41 = { class: "component_title" }
const _hoisted_42 = { class: "two_block_wrapper" }
const _hoisted_43 = { class: "top_half_left mb-4" }
const _hoisted_44 = { class: "top_half_right mb-4" }
const _hoisted_45 = { class: "top_half_right mb-4" }
const _hoisted_46 = { class: "input_label" }
const _hoisted_47 = ["src"]
const _hoisted_48 = { class: "flex mt-3" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/assets/img/delete.svg" }, null, -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = { class: "w-100 mt-2 mb-3" }
const _hoisted_52 = { class: "flex" }
const _hoisted_53 = { class: "periodic_wrapper" }
const _hoisted_54 = { class: "button_wrapper mt-3" }

export function render(_ctx, _cache) {
  const _component_v_input = _resolveComponent("v-input")
  const _component_v_select = _resolveComponent("v-select")
  const _component_quill_editor = _resolveComponent("quill-editor")
  const _component_v_textarea = _resolveComponent("v-textarea")
  const _component_v_checkbox = _resolveComponent("v-checkbox")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.$router.go(-1))),
        class: "button button_back"
      }, [
        _hoisted_3,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('training_class.view.back')), 1)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.mailing?.subject), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('mailings.view.mailing_type')), 1),
              _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.mailingTypeName), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('mailings.view.creator')), 1),
              _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.userName), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('mailings.send_date')), 1),
              _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.getFormatedDate(_ctx.mailing?.sendingDate, "DD.MM.yyyy HH:mm")), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t('mailings.view.mailing_group')), 1),
              _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.mailingGroupName), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t('mailings.view.clubs')), 1),
            _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.getSelectedClubNames()), 1)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t('mailings.view.periodic')), 1),
            _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.mailing?.isPeriodic && _ctx.mailing?.periodsNumber && _ctx.mailing?.periodTypeName ? `${_ctx.$t('interval_measure.' + _ctx.mailing.periodTypeName.toLowerCase())}: ${_ctx.mailing.periodsNumber}` : _ctx.$t('mailings.view.no')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t('mailings.view.message')), 1),
          _createElementVNode("div", {
            innerHTML: _ctx.mailing?.body
          }, null, 8, _hoisted_31)
        ]),
        (_ctx.mailingType == 'notification' && _ctx.mailing?.imageUrl)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.$t('mailings.view.attached_image')), 1),
              _createElementVNode("img", {
                class: "notification_img",
                src: _ctx.mailing?.imageUrl
              }, null, 8, _hoisted_34)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_35, [
          (_ctx.isNew)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "primary_button button_space",
                onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.edit && _ctx.edit(...args))),
                diasbled: _ctx.isButtonDisabled
              }, _toDisplayString(_ctx.$t('mailings.view.edit')), 9, _hoisted_36))
            : _createCommentVNode("", true),
          (_ctx.isNew)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "change_status_button",
                onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.publish && _ctx.publish(...args))),
                diasbled: _ctx.isButtonDisabled
              }, _toDisplayString(_ctx.$t('mailings.view.publish')), 9, _hoisted_37))
            : _createCommentVNode("", true),
          (!_ctx.isNew && !_ctx.isStoped && _ctx.mailing?.isPeriodic)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "change_status_button",
                onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.stop && _ctx.stop(...args))),
                diasbled: _ctx.isButtonDisabled
              }, _toDisplayString(_ctx.$t('mailings.view.stop')), 9, _hoisted_38))
            : _createCommentVNode("", true),
          (_ctx.isStoped && _ctx.mailing?.isPeriodic)
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                class: "change_status_button",
                onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.resume && _ctx.resume(...args))),
                diasbled: _ctx.isButtonDisabled
              }, _toDisplayString(_ctx.$t('mailings.view.resume')), 9, _hoisted_39))
            : _createCommentVNode("", true)
        ])
      ], 512), [
        [_vShow, !_ctx.isEdit]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_40, [
        _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.$t('mailings.view.edit_mailing')), 1),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createVNode(_component_v_input, {
              modelValue: _ctx.subject,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.subject) = $event)),
              label: _ctx.$t('mailings.view.subject'),
              height: "22",
              errorText: _ctx.subjectErrorText,
              onFocus: _cache[6] || (_cache[6] = $event => (_ctx.subjectErrorText = '')),
              clearable: ""
            }, null, 8, ["modelValue", "label", "errorText"])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createVNode(_component_v_select, {
              modelValue: _ctx.selectedClubs,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.selectedClubs) = $event)),
              label: 'mailings.view.clubs',
              items: _ctx.clubs,
              errorText: _ctx.clubErrorText,
              onClick: _cache[8] || (_cache[8] = $event => (_ctx.clubErrorText = '')),
              multiple: "",
              clearable: ""
            }, null, 8, ["modelValue", "label", "items", "errorText"])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.mailingType != 'notification' ? 'two_block_wrapper' : 'one_block_wrapper')
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.mailingType != 'notification' ? 'top_half_left mb-4' : 'w-100 mb-4')
          }, [
            _createVNode(_component_v_select, {
              modelValue: _ctx.selectedMailingGroup,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.selectedMailingGroup) = $event)),
              label: 'mailings.view.mailing_group',
              items: _ctx.mailingGroups,
              errorText: _ctx.mailingGroupErrorText,
              onClick: _cache[10] || (_cache[10] = $event => (_ctx.mailingGroupErrorText = ''))
            }, null, 8, ["modelValue", "label", "items", "errorText"])
          ], 2),
          _withDirectives(_createElementVNode("div", _hoisted_45, [
            _createVNode(_component_v_select, {
              modelValue: _ctx.selectedType,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.selectedType) = $event)),
              label: 'mailings.view.type',
              items: _ctx.types
            }, null, 8, ["modelValue", "label", "items"])
          ], 512), [
            [_vShow, _ctx.mailingType != 'notification']
          ])
        ], 2),
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass([{ edit_error: _ctx.editorMessageErrorText }, "mt-1 edit position-relative"])
        }, [
          _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t('mailings.view.message')), 1),
          _createVNode(_component_quill_editor, {
            value: _ctx.editorMessage,
            "onUpdate:value": _cache[12] || (_cache[12] = $event => ((_ctx.editorMessage) = $event)),
            options: _ctx.editorOption,
            onFocus: _cache[13] || (_cache[13] = $event => (_ctx.editorMessageErrorText = ''))
          }, null, 8, ["value", "options"]),
          _withDirectives(_createElementVNode("span", { class: "span_error" }, _toDisplayString(_ctx.messageErrorText), 513), [
            [_vShow, _ctx.editorMessageErrorText]
          ])
        ], 2), [
          [_vShow, _ctx.mailingType == 'mail']
        ]),
        _withDirectives(_createVNode(_component_v_textarea, {
          class: "mt-5",
          modelValue: _ctx.message,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ((_ctx.message) = $event)),
          label: _ctx.$t('mailings.view.message'),
          errorText: _ctx.messageErrorText,
          onFocus: _cache[15] || (_cache[15] = $event => (_ctx.messageErrorText = ''))
        }, null, 8, ["modelValue", "label", "errorText"]), [
          [_vShow, _ctx.mailingType != 'mail']
        ]),
        _withDirectives(_createElementVNode("div", null, [
          (_ctx.tempImg)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "notification_img",
                src: _ctx.tempImg
              }, null, 8, _hoisted_47))
            : _createCommentVNode("", true),
          _createElementVNode("input", {
            type: "file",
            hidden: "",
            ref: "fileInput",
            onChange: _cache[16] || (_cache[16] = (...args) => (_ctx.addImg && _ctx.addImg(...args)))
          }, null, 544),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("button", {
              class: "primary_button",
              onClick: _cache[17] || (_cache[17] = $event => (_ctx.$refs.fileInput.click()))
            }, _toDisplayString(_ctx.$t('mailings.view.add_img')), 1),
            (_ctx.tempImg)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "img_delete_button",
                  onClick: _cache[18] || (_cache[18] = (...args) => (_ctx.removeImg && _ctx.removeImg(...args)))
                }, _hoisted_50))
              : _createCommentVNode("", true)
          ])
        ], 512), [
          [_vShow, _ctx.mailingType == 'notification']
        ]),
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _createVNode(_component_v_checkbox, {
              modelValue: _ctx.isPeriodic,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => ((_ctx.isPeriodic) = $event)),
              label: _ctx.$t('mailings.view.periodic')
            }, null, 8, ["modelValue", "label"])
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_53, [
          _createVNode(_component_v_select, {
            class: "small_input period_type",
            modelValue: _ctx.selectedPeriodType,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => ((_ctx.selectedPeriodType) = $event)),
            label: 'mailings.view.period_type',
            items: _ctx.periodTypes
          }, null, 8, ["modelValue", "label", "items"]),
          _createVNode(_component_v_input, {
            class: "small_input",
            modelValue: _ctx.repetitionPeriod,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => ((_ctx.repetitionPeriod) = $event)),
            label: _ctx.$t('mailings.view.repetition_period'),
            height: "22",
            errorText: _ctx.repetitionPeriodErrorText,
            onFocus: _cache[22] || (_cache[22] = $event => (_ctx.repetitionPeriodErrorText = '')),
            clearable: ""
          }, null, 8, ["modelValue", "label", "errorText"])
        ], 512), [
          [_vShow, _ctx.isPeriodic]
        ]),
        _createVNode(_component_v_input, {
          class: "date_input",
          modelValue: _ctx.sendDate,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => ((_ctx.sendDate) = $event)),
          label: _ctx.$t('mailings.send_date'),
          inputType: "datetime-local",
          height: "22",
          errorText: _ctx.sendDateErrorText,
          onFocus: _cache[24] || (_cache[24] = $event => (_ctx.sendDateErrorText = '')),
          clearable: ""
        }, null, 8, ["modelValue", "label", "errorText"]),
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("button", {
            class: "primary_button save_button",
            onClick: _cache[25] || (_cache[25] = (...args) => (_ctx.save && _ctx.save(...args)))
          }, _toDisplayString(_ctx.$t('mailings.view.save')), 1),
          _createElementVNode("button", {
            class: "secondary_button cancel_button",
            onClick: _cache[26] || (_cache[26] = $event => (_ctx.isEdit=false))
          }, _toDisplayString(_ctx.$t('mailings.view.cancel')), 1)
        ])
      ], 512), [
        [_vShow, _ctx.isEdit]
      ])
    ])
  ]))
}